import React, { useRef, useState, useEffect } from 'react'
import { useAppState } from '../context/AppState'
import { loadFile, exportJSON, exportCSV, downloadFile } from '../utils/importExport'

const GOAL_KEYS = [
  { key: 'professionalYearly', label: 'Professional yearly goal' },
  { key: 'privateYearly', label: 'Private yearly goal' },
  { key: 'professionalMonthly', label: 'Professional monthly goal' },
  { key: 'privateMonthly', label: 'Private monthly goal' },
  { key: 'professionalWeekly', label: 'Professional weekly goal' },
  { key: 'privateWeekly', label: 'Private weekly goal' },
]

export function GoalsInSight({ open, onClose }) {
  const { state, setGoal, loadState } = useAppState()
  const fileInputRef = useRef(null)
  const exportWrapRef = useRef(null)
  const [exportMenuOpen, setExportMenuOpen] = useState(false)

  useEffect(() => {
    if (!exportMenuOpen) return
    const close = (e) => {
      if (exportWrapRef.current?.contains(e.target)) return
      setExportMenuOpen(false)
    }
    document.addEventListener('pointerdown', close)
    return () => document.removeEventListener('pointerdown', close)
  }, [exportMenuOpen])

  const handleImport = async (e) => {
    const file = e.target?.files?.[0]
    if (!file) return
    try {
      const newState = await loadFile(file)
      loadState(newState)
      onClose()
    } catch (err) {
      console.error(err)
      alert('Import failed. Use a .json or .csv export from this app.')
    }
    e.target.value = ''
  }

  const handleExport = (format) => {
    setExportMenuOpen(false)
    if (format === 'json') {
      downloadFile(exportJSON(state), 'grim-goals.json', 'application/json')
    } else {
      downloadFile(exportCSV(state), 'grim-goals.csv', 'text/csv')
    }
  }

  if (!open) return null

  return (
    <div className="goals-overlay" onClick={onClose}>
      <div className="goals-panel" onClick={(e) => e.stopPropagation()}>
        <div className="goals-panel-header">
          <h2>Goals — keep them in sight</h2>
          <button type="button" className="close-btn" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="goals-list">
          {GOAL_KEYS.map(({ key, label }) => (
            <div key={key} className="goal-row">
              <label htmlFor={key}>{label}</label>
              <input
                id={key}
                type="text"
                value={state.goals[key] ?? ''}
                onChange={(e) => setGoal(key, e.target.value)}
                placeholder="Set your goal…"
              />
            </div>
          ))}
        </div>
        <div className="goals-actions">
          <input
            ref={fileInputRef}
            type="file"
            accept=".json,.csv"
            className="file-input-hidden"
            onChange={handleImport}
          />
          <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
          >
            Import from file
          </button>
          <div className="goals-export-wrap" ref={exportWrapRef}>
            <button
              type="button"
              onClick={() => setExportMenuOpen((open) => !open)}
              aria-expanded={exportMenuOpen}
              aria-haspopup="menu"
            >
              Export
            </button>
            {exportMenuOpen && (
              <div className="goals-export-dropdown" role="menu">
                <button type="button" onClick={() => handleExport('json')}>
                  JSON
                </button>
                <button type="button" onClick={() => handleExport('csv')}>
                  CSV
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
